/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { User } from './common';

export type TeamId = string;

export const NEBULA_TEAM_ID = '75e51c1d-8fac-4789-93e7-660d67cf4951';

export type Team = {
  id: TeamId;
  name: string;
  members: TeamMember[];
  type: TeamType;
};
/**
 *
 * `Personal team`:
 *
 * Created for each user and includes only this user.
 *
 * `Global team`:
 *
 * Includes all users. Can be shown when the account.globalTeam.enabled option is enabled.
 *
 * `Regular team`:
 *
 * Created by users to invite other users to it. NebulaTeam - is regular team too.
 *
 * `Cluster team`:
 *
 * Created for each cluster to invite other users into it.
 *
 */
export enum TeamType {
  personal = 'PERSONAL',
  global = 'GLOBAL',
  regular = 'REGULAR',
  cluster = 'CLUSTER',
}

export enum TeamAuthority {
  owner = 'OWNER',
  user = 'USER',
}

export type TeamMember = Pick<User, 'firstName' | 'lastName' | 'email'> & {
  lastActivity: number;
  authorities: TeamAuthority[];
  isMe: boolean;
};

export type CreateTeamRequestBody = Pick<Team, 'name' | 'id'>;
export type CreateTeamResponseBody = Team;
export type EditTeamRequestBody = Partial<Omit<Team, 'id' | 'members'>>;
export type UpdateTeamMemberAuthoritiesRequestBody = { authorities: TeamAuthority[] };
export type InviteTeamUsersRequestBody = { names: string[] };

export type InviteTeamUsersResponse = { failed: { id: string; reason: string }[] };
